import { RouteObject, Outlet, Navigate } from 'react-router-dom';
import type { RouterProps } from 'contracts/Router';
import {
  ChecklistMemberCreationPage,
  ChecklistMemberUpdatePage,
  ChecklistMembersListPage,
} from 'pages/ChecklistMembers';

const checklistMemberRoutes = ({
  location,
  userBelongsToAnyOf,
}: RouterProps): RouteObject => ({
  path: 'configuracoes/checklist/usuarios',
  element: userBelongsToAnyOf('admin') ? (
    <Outlet />
  ) : (
    <Navigate to="/" state={{ from: location }} />
  ),
  children: [
    {
      path: '',
      element: <ChecklistMembersListPage />,
    },
    {
      path: 'criar',
      element: <ChecklistMemberCreationPage />,
    },
    {
      path: ':id/editar',
      element: <ChecklistMemberUpdatePage />,
    },
  ],
});

export default checklistMemberRoutes;
